import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M16.472 3L21 15.389C21 15.389 20.992 15.392 20.278 15.651C18.426 13.975 14.839 14.339 13.194 14.617C12.691 14.706 12.195 14.839 11.714 15.013L11.498 15.091L14.588 19.331C14.927 19.797 14.723 20.47 14.167 20.672L13.404 20.949C13.039 21.081 12.625 20.951 12.387 20.635L9.01002 15.994L5.69302 17.197C5.23702 17.362 4.72802 17.126 4.56202 16.672L3.05302 12.542C2.88702 12.087 3.12402 11.58 3.58002 11.414L9.60102 9.231C10.082 9.057 10.548 8.841 10.99 8.587C12.43 7.747 15.412 5.731 15.749 3.261C16.14 3.12 16.472 3 16.472 3V3Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'MegaphoneFill');

export default Icon;
